import '@/lib/alertifyjs/css/alertify.custom.css';
import '@/lib/alertifyjs/css/themes/bootstrap.custom.css';
import '~/css/shared/alerts.css';
import '~/css/shared/close.css';

import alertify from '@/lib/alertifyjs/alertify-custom';

alertify.defaults.theme.ok = "btn btn-lg btn-primary";
alertify.defaults.theme.cancel = "btn btn-lg btn-default";
alertify.defaults.theme.input = "form-control";
alertify.defaults.movable = false;
alertify.defaults.maximizable = false;
alertify.defaults.resizable = false;
alertify.defaults.transition = 'slide';

export default alertify;
